import { formatVal } from '../../../helpers/value'

export const convertDataVSIC = (data) => {
  return data.map((item) => ({
    ...item,
    label: item.name,
    value: item.id,
  }))
}

export const handelTotalCompany = (data) =>
  data.reduce(
    (accumulator, currentValue) => accumulator + currentValue.count,
    0,
  )

export const convertDataChart = (data) => {
  const total = handelTotalCompany(data)
  return [...data].map((item, index) => ({
    ...item,
    color: item.colorCode,
    percent: Number(formatVal((item.count / total) * 100)),
  }))
}

export const handleGetParentVSIC = (dataVSIC, userProfile, id, level) => {
  if (!dataVSIC.length || !level || !id) return
  if (+level <= 3) {
    return {
      id: userProfile?.companyVSICId,
      label: userProfile?.companyIndustry,
      name: userProfile?.companyIndustry,
      code: userProfile?.companyVSICCode,
    }
  }
  let obj = dataVSIC.find((item) => item.id === id)
  const arr = [...Array(level - 3)]
  arr.forEach((_) => {
    obj = dataVSIC.find((item) => item.id === obj.parentId)
  })

  return {
    ...obj,
    label: obj?.name,
  }
}
